import { useEffect } from 'react';

/**
 * Хук для подписки компонента на указанное событие
 *
 * @param eventTarget - объект, к которому добавляется event listener
 * @param type - название события
 * @param listener - вызывается при совершении события
 */
export function useSubscribeOn(
    eventTarget: EventTarget,
    type: string,
    listener: EventListenerOrEventListenerObject | null,
) {
    useEffect(() => {
        eventTarget.addEventListener(type, listener);
        return () => eventTarget.removeEventListener(type, listener);
    }, []);
}
